import { Injectable, inject } from '@angular/core';
import {
  WatchAlert,
  WatchAlertConfigService,
  WatchAlertDTO,
  WatchAlertRequestDTO,
} from '@compumark/order-management-client';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertApiClientService {
  private watchAlertConfigService = inject(WatchAlertConfigService);

  getAlerts(): Observable<WatchAlert[]> {
    return this.watchAlertConfigService.getWatchAlerts();
  }

  getWatchAlertById(alertId: string): Observable<WatchAlert> {
    return this.watchAlertConfigService.getWatchAlert(alertId);
  }

  updateAlert(alert: WatchAlert): Observable<WatchAlert> {
    return this.watchAlertConfigService.updateWatchAlert(alert, alert.id!);
  }

  disableAll(disable: boolean): Observable<boolean> {
    return this.watchAlertConfigService.disableAlertConfig(disable);
  }

  isAlertConfigDisabled(): Observable<boolean> {
    return this.watchAlertConfigService.isAlertConfigDisabled();
  }

  deleteAlert(alertId: string): Observable<void> {
    return this.watchAlertConfigService.deleteWatchAlert(alertId);
  }

  createAlert(request: WatchAlertRequestDTO): Observable<WatchAlertDTO> {
    return this.watchAlertConfigService.createWatchAlert(request);
  }

  copyOrderToWatchAlert(
    targetAlertId: string,
    orderNumber: string,
  ): Observable<void> {
    return this.watchAlertConfigService.copyOrderToWatchAlert(
      targetAlertId,
      orderNumber,
    );
  }

  deleteWatchOrder(alertId: string, watchOrderId: string): Observable<void> {
    return this.watchAlertConfigService.deleteOrderByWatchAlertId(
      alertId,
      watchOrderId,
    );
  }

  moveOrderBetweenWatchAlerts(
    sourceAlertId: string,
    targetAlertId: string,
    watchOrderId: string,
  ): Observable<void> {
    return this.watchAlertConfigService.moveOrderBetweenWatchAlerts(
      sourceAlertId,
      targetAlertId,
      watchOrderId,
    );
  }
  copyOrdersToWatchAlert(
    targetAlertId: string,
    orderNumbers: string[],
  ): Observable<void> {
    return this.watchAlertConfigService.copyOrdersToWatchAlert(
      orderNumbers as any,
      targetAlertId,
    );
  }

  setWatchAlertOrders(
    alertId: string,
    orderNumbers: string[],
  ): Observable<void> {
    return this.watchAlertConfigService.setWatchAlertOrders(
      orderNumbers as any,
      alertId,
    );
  }

  deleteOrdersFromWatchAlert(
    sourceAlertId: string,
    orderNumbers: string[],
  ): Observable<void> {
    return this.watchAlertConfigService.deleteOrdersFromWatchAlert(
      orderNumbers as any,
      sourceAlertId,
    );
  }

  moveOrdersBetweenWatchAlerts(
    sourceAlertId: string,
    targetAlertId: string,
    orderNumbers: string[],
  ): Observable<void> {
    return this.watchAlertConfigService.moveOrdersBetweenWatchAlerts(
      orderNumbers as any,
      sourceAlertId,
      targetAlertId,
    );
  }
}
